import { createElement } from 'react'
import clsx from 'clsx'

import { useAppSelector } from '@/store/hook'
import { selectCurrencySymbol, selectIsCurrencyFront } from '@/store/selectors/configSelector'
import { selectNumberSeparator, selectUserCurrency } from '@/store/selectors/userSelector'
import { formatPrice } from '@/libs/utils/handleNumber'

import styles from './FormatPrice.module.scss'

interface FormatPriceProps {
  price?: number | string
  currencyUnit?: string
  wrappedBy?: string
  className?: string
  style?: React.CSSProperties
}

const FormatPrice = ({
  price = 0,
  currencyUnit = '',
  wrappedBy = 'span',
  className,
  style,
}: FormatPriceProps) => {
  let Comp = 'span'

  const userCurrencyUnit = useAppSelector(selectUserCurrency)
  const numberSeparator = useAppSelector(selectNumberSeparator)
  const isCurrencyFront = useAppSelector(selectIsCurrencyFront)
  const currencySymbol = useAppSelector(selectCurrencySymbol)
  const formattedPrice = formatPrice(
    // For some pages such as:
    // Cart,... we will use the currency unit from SAP
    price,
    currencyUnit || userCurrencyUnit,
    numberSeparator,
    isCurrencyFront,
    currencySymbol,
  )

  if (wrappedBy) {
    Comp = wrappedBy
  }

  return createElement(
    Comp,
    { className: clsx(styles.formatPrice, className), style },
    formattedPrice,
  )
}

export default FormatPrice
